import { render, staticRenderFns } from "./LedgerNumbers.vue?vue&type=template&id=5c7f55a8"
import script from "./LedgerNumbers.vue?vue&type=script&lang=js"
export * from "./LedgerNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports